export const profileData = {
  name: "Venkata Nikhit Mulkala",
  title: "Cloud & DevOps Engineer | AWS DevOps Certified Professional",
  summary: "IT professional with 9+ years of experience architecting and managing cloud solutions across AWS and GCP. Skilled in building scalable, secure, and highly available infrastructure using Kubernetes, Terraform, and modern CI/CD practices.",
  contact: {
    email: "nikhit.tech@gmail.com",
    linkedin: "www.linkedin.com/in/venkatm-240b7a195",
    portfolio: "mvnportfolio.azurewebsites.net"
  }
};

export const projects = [
  {
    id: 1,
    company: "McAfee",
    role: "Cloud & DevOps Engineer",
    duration: "January 2022 - Present (4 years)",
    location: "Frisco, TX",
    image: "https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/vkmwgvww_mcafee-internet-security_881r.jpg",
    description: "Architecting and managing cloud solutions for enterprise security products. Leading infrastructure automation and CI/CD implementations.",
    technologies: ["AWS", "GCP", "Kubernetes", "Terraform", "CI/CD", "Docker", "Jenkins", "Python"],
    category: ["current", "cloud", "devops", "aws", "gcp"],
    achievements: [
      "Designed and implemented multi-region cloud infrastructure",
      "Automated deployment pipelines reducing release time by 60%",
      "Led migration of legacy systems to containerized architecture",
      "Implemented monitoring and alerting systems for 99.9% uptime"
    ]
  },
  {
    id: 2,
    company: "Integrity Marketing Group",
    role: "DevOps Engineer",
    duration: "April 2021 - January 2022 (10 months)",
    location: "Dallas, TX",
    image: "https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/t3wtikfo_Integrrity.png",
    description: "Implemented DevOps practices and cloud infrastructure for marketing technology platforms.",
    technologies: ["AWS", "Terraform", "CI/CD", "Docker", "Jenkins", "Python", "Ansible"],
    category: ["devops", "aws", "automation"],
    achievements: [
      "Established CI/CD pipelines for multiple microservices",
      "Reduced infrastructure costs by 35% through optimization",
      "Implemented Infrastructure as Code using Terraform",
      "Automated server provisioning and configuration management"
    ]
  },
  {
    id: 3,
    company: "General Motors",
    role: "DevOps SRE Engineer",
    duration: "March 2020 - March 2021 (1 year 1 month)",
    location: "Remote",
    image: "https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/kczcmdn8_download%20%281%29.png",
    description: "Site Reliability Engineering for automotive cloud platforms. Focused on system reliability, monitoring, and incident management.",
    technologies: ["AWS", "Kubernetes", "Prometheus", "Grafana", "Python", "Terraform", "Splunk"],
    category: ["sre", "devops", "aws", "monitoring"],
    achievements: [
      "Achieved 99.95% uptime for critical production systems",
      "Implemented comprehensive monitoring and alerting solutions",
      "Reduced incident response time by 50%",
      "Automated disaster recovery procedures"
    ]
  },
  {
    id: 4,
    company: "Google",
    role: "Cloud Engineer",
    duration: "February 2019 - January 2020 (12 months)",
    location: "San Francisco, California, United States",
    image: "https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/bky89y0p_download.png",
    description: "Cloud infrastructure engineering for Google Cloud Platform. Worked on scalable cloud solutions and infrastructure automation.",
    technologies: ["GCP", "Kubernetes", "Terraform", "Python", "Cloud Functions", "BigQuery"],
    category: ["cloud", "gcp", "google"],
    achievements: [
      "Developed cloud-native applications on GCP",
      "Implemented serverless architectures using Cloud Functions",
      "Optimized data pipelines for big data processing",
      "Collaborated with cross-functional teams on cloud migrations"
    ]
  },
  {
    id: 5,
    company: "[24]7.ai",
    role: "Linux System Administrator",
    duration: "Previous Experience",
    location: "Remote",
    image: "https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/b4m5yh8n_%2824%297.ai_Logo.svg.png",
    description: "Linux systems administration for AI-powered customer service platforms. Managed server infrastructure and ensured system reliability.",
    technologies: ["Linux", "Bash", "Python", "Nagios", "Apache", "MySQL", "Shell Scripting"],
    category: ["linux", "sysadmin", "infrastructure"],
    achievements: [
      "Managed and maintained 200+ Linux servers",
      "Automated routine maintenance tasks",
      "Implemented backup and recovery procedures",
      "Provided 24/7 on-call support for critical systems"
    ]
  }
];

export const skills = [
  { name: "AWS", category: "Cloud Platforms" },
  { name: "GCP", category: "Cloud Platforms" },
  { name: "Azure", category: "Cloud Platforms" },
  { name: "Kubernetes", category: "Containerization" },
  { name: "Docker", category: "Containerization" },
  { name: "Terraform", category: "IaC" },
  { name: "CI/CD", category: "DevOps" },
  { name: "Jenkins", category: "DevOps" },
  { name: "Python", category: "Programming" },
  { name: "Splunk", category: "Monitoring" },
  { name: "Prometheus", category: "Monitoring" },
  { name: "Grafana", category: "Monitoring" }
];

export const certifications = [
  "Professional Cloud DevOps Engineer Certification",
  "AWS Certified DevOps Engineer - Professional"
];